// For jsPDF: { dataUrl, width, height } as PNG, or null when the image cannot be loaded (e.g. CORS).
// maxWidth / maxHeight scale the image down (never up) so a large source does not bloat the PDF.
export const toPngDataUrl = async (url, { maxWidth = Infinity, maxHeight = Infinity } = {}) => {
  if (!url) return null
  try {
    const source = new URL(url)
    source.searchParams.set('_cb', Date.now().toString())
    const res = await fetch(source.toString())
    if (!res.ok) return null

    const blob = await res.blob()
    const objectUrl = URL.createObjectURL(blob)
    try {
      const img = await new Promise((resolve, reject) => {
        const image = new Image()
        image.onload = () => resolve(image)
        image.onerror = reject
        image.src = objectUrl
      })
      const naturalWidth = img.naturalWidth || img.width
      const naturalHeight = img.naturalHeight || img.height
      const scale = Math.min(1, maxWidth / naturalWidth, maxHeight / naturalHeight)
      const canvas = document.createElement('canvas')
      canvas.width = Math.max(1, Math.round(naturalWidth * scale))
      canvas.height = Math.max(1, Math.round(naturalHeight * scale))
      const context = canvas.getContext('2d')
      context.imageSmoothingQuality = 'high'
      context.drawImage(img, 0, 0, canvas.width, canvas.height)
      return { dataUrl: canvas.toDataURL('image/png'), width: canvas.width, height: canvas.height }
    } finally {
      URL.revokeObjectURL(objectUrl)
    }
  } catch (err) {
    return null
  }
}
